export default __webpack_public_path__ + "static/media/icon-close.d47fda63.svg";